import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { EventProvider, SubscribeProvider } from './context';
export const RegisterWebCompSetup = (props) => {
    const { config, eventDispatcher, subscribeDispatcher } = props;
    if (config.events) {
        return (_jsx(EventProvider, { value: eventDispatcher, children: _jsx(SubscribeProvider, { value: subscribeDispatcher, children: props.children }) }));
    }
    return _jsx(_Fragment, { children: props.children });
};
